import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";

const CreateContentModal = ({
  open,
  onClose,
  onCourseClick,
  onHandoutClick,
  heading,
  buttonText1,
  buttonText2,
  text,
  headingColor,
  backgroundColor,
  buttonBgColor1,
  textColor,
}: any) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="create-content-modal-title"
      aria-describedby="create-content-modal-description"
    >
      <Box sx={modalStyle.modalContainer}>
        <Box display="flex" justifyContent="flex-end" p={2}>
          <ClearOutlinedIcon
            sx={{ color: "gray", cursor: "pointer" }}
            onClick={onClose}
          />
        </Box>
        <Box textAlign="center" pb={4}>
          <Typography
            fontSize={{ xs: 16, md: 18 }}
            fontWeight={600}
            mb={4}
            px={{ xs: 8, md: 0 }}
            // color={headingColor}
            sx={{ color: "#233F91" }}
          >
            {heading}
          </Typography>
          <Typography
            fontSize={17}
            fontWeight={400}
            mb={4}
            px={{ xs: 8, md: 8 }}
            color={"#2E2E2E"}
          >
            {text}
          </Typography>
          <Box display="flex" justifyContent="center" gap={2} pb={4}>
            <Button
              variant="contained"
              onClick={onCourseClick}
              // sx={modalStyle.modalBtn}
              sx={{
                ...modalStyle.modalBtn,
                backgroundColor:
                  buttonBgColor1 || modalStyle.modalBtn.backgroundColor,
                color: textColor || modalStyle.modalBtn.color,
              }}
            >
              {/* Course */}
              {buttonText1}
            </Button>
            <Button
              variant="contained"
              onClick={onHandoutClick}
              sx={modalStyle.modalBtn2}
            >
              {/* Handout */}
              {buttonText2}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default CreateContentModal;

const modalStyle = {
  modalContainer: {
    width: { xs: 353, md: 626 },
    top: "50%",
    left: "50%",
    boxShadow: 0,
    border: "none",
    borderRadius: "10px",
    bgcolor: "background.paper",
    position: "absolute" as "absolute",
    transform: "translate(-50%, -50%)",
  },
  modalBtn: {
    width: { xs: "144px", md: "156px" },
    height: "48px",
    color: "#fff",
    borderRadius: "15px",
    mt: 2,
    py: 1,
    backgroundColor: "#233F91",
    border: "1.5px solid #233F91",
  },
  modalBtn2: {
    width: { xs: "144px", md: "156px" },
    height: "48px",
    color: "#fff",
    borderRadius: "15px",
    mt: 2,
    py: 1,
    backgroundColor: "#233F91",
  },
};
